var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.994,
    height: 43.321,
    viewBox: "0 0 43.994 43.321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16579",
    "data-name": "Group 16579",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16578",
    "data-name": "Group 16578",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19248",
    "data-name": "Path 19248",
    d: "M42.3,20.327H39.945A18.75,18.75,0,1,0,8.572,35.582c-.02-.271-.041-.528-.054-.758a24.206,24.206,0,0,1,.061-3.418A15.932,15.932,0,1,1,37.122,20.327H34.9a.705.705,0,0,0-.611,1.058l3.7,6.411a.7.7,0,0,0,1.221,0l3.7-6.411A.705.705,0,0,0,42.3,20.327Z",
    transform: "translate(-2.501 -2.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16577",
    "data-name": "Group 16577",
    transform: "translate(7.337 8.982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19249",
    "data-name": "Path 19249",
    d: "M28.428,27.348a22.61,22.61,0,0,0-8.813-.007V23.328a4.406,4.406,0,0,1,8.813,0Zm3.946,1.773a5.046,5.046,0,0,0-1.3-.893v-4.9a7.053,7.053,0,1,0-14.106,0v4.9a4.931,4.931,0,0,0-1.3.893c-2.958,2.951-3.249,14.079,0,16.7,2.152,1.74,7.364,2.328,11.581,1.76V41.3a3.125,3.125,0,0,1,2.626-3.086V35.457a1.9,1.9,0,0,1,1.9-1.9,1.852,1.852,0,0,1,1.333.555l1.489,1.49C34.323,32.844,33.565,30.313,32.374,29.121Zm-6.6,11.344H22.269l.636-3.282a2.376,2.376,0,1,1,2.234,0Z",
    transform: "translate(-13.34 -16.268)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_19250",
    "data-name": "Path 19250",
    d: "M55.517,48.439H43.9l-4.462-4.462a.538.538,0,0,0-.919.38v4.081h-.862a1.767,1.767,0,0,0-1.767,1.768v7.535a1.768,1.768,0,0,0,1.767,1.768H55.517a1.768,1.768,0,0,0,1.768-1.768V50.207A1.768,1.768,0,0,0,55.517,48.439ZM41.3,55.394l-.736.514-.795-1.063-.807,1.063-.736-.514.795-1.134-1.215-.374.269-.853,1.192.4V52.041h.993v1.391l1.18-.4.281.853-1.227.374Zm4.548,0-.736.514-.795-1.063-.807,1.063-.735-.514.794-1.134-1.215-.374.269-.853,1.192.4V52.041h.994v1.391l1.18-.4.28.853-1.227.374Zm4.548,0-.736.514-.795-1.063-.807,1.063-.735-.514.794-1.134L46.9,53.887l.269-.853,1.192.4V52.041h.994v1.391l1.18-.4.28.853-1.227.374Zm4.548,0-.736.514-.795-1.063-.807,1.063-.735-.514.795-1.134-1.216-.374.269-.853,1.192.4V52.041h.994v1.391l1.18-.4.28.853-1.227.374Z",
    transform: "translate(-13.29 -16.188)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.956ea38b33aeb715c36119fe11297b2a.svg";
export { ForwardRef as ReactComponent };